@if (complexFieldDefinition) {
  <span class="sh-icon-label">
    {{label}}
    <a id="openDialogIcon" [title]="'actions.view-details' | translate" class="sh-icon-label__icon sh-link -sh-superscript" (click)="showComplexValue()">
      <svg sh-icon [size]="'small'" aria-hidden="true" [name]="'info'"></svg>
    </a>
  </span>
}
